<template>
    <div>
        <div>
            <eventReport></eventReport>
            <proReport></proReport>
            <otherRefining></otherRefining>
        </div>
    </div>
</template>

<script>
    import eventReport from './eventReportDetailed/index'
    import proReport from './proReportDetailed/index'
    import otherRefining from '../reportRefining/index'

    export default {

        components:{
            eventReport,
            proReport,
            otherRefining

        }
    }
</script>

<style scoped>

</style>
